module.exports = __webpack_public_path__ + "img/banner.94e8f19e.png";